import styled from "styled-components";
import { buttonResetStyles } from "../../../utils";
import { colors } from "../../../utils/colors";

export const Outer = styled.div`
    padding-top: 16px;
`;

export const Wrapper = styled.div`
    position: relative;
    background-color: #ffce00;
    padding: 12px;
    border-radius: 4px;

    display: flex;
    gap: 8px;
    align-items: center;

    color: ${colors.brandDark};
`;

export const Content = styled.div`
    * {
        font-size: 0.8rem;
        font-weight: 500;
        margin: 0;
        color: ${colors.brandDark};

        a {
            color: ${colors.brandDark};
        }

        @media only screen and (min-width: 640px) {
            font-size: 0.9rem
        }
    }
`;

export const CloseButton = styled.button`
    ${buttonResetStyles};
    width: 26px;
    height: 26px;
    background-color: white;
    border-radius: 50%;

    display: flex;
    align-items: center;
    justify-content: center;

    position: absolute;
    top: 0;
    right: 0;

    transform: translate(40%, -40%);
`;
